module.exports = {
      id: "line-arrow-next-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#line-arrow-next",
      toString: function () {
        return this.url;
      }
    }